import React from 'react';
import HubspotForm from 'react-hubspot-form';
import { appendTooltip } from '@commons/append-tooltip/appendTooltip';
import { LoadingSpinner } from '@commons/loading-spinner/LoadingSpinner';
import { privatePolicyInfo } from '@commons/append-tooltip/payload';

export function NewsletterForm({ runSetFormSubmitted, formId }) {
  const policyInfo = privatePolicyInfo.type2;
  return (
    <HubspotForm
      region="na1"
      portalId="5206705"
      formId={formId}
      loading={<LoadingSpinner />}
      onReady={() => appendTooltip('#subscribeNewsletterForm', policyInfo)}
      onSubmit={() => undefined}
      onFormSubmitted={() => {
        runSetFormSubmitted();
      }}
    />
  );
}
